"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAllowedDomain = void 0;
var WHITELISTED_DOMAINS = ['.hlag.cloud', '.hapag-lloyd.com', '.hapag-lloyd.cn', 'localhost:8080'];
var isAllowedDomain = function isAllowedDomain(url) {
  try {
    var _URL = new URL(url),
      origin = _URL.origin;
    return WHITELISTED_DOMAINS.filter(function (whitelistedDomain) {
      return origin.endsWith(whitelistedDomain);
    }).length > 0;
  } catch (_a) {
    return false;
  }
};
exports.isAllowedDomain = isAllowedDomain;
//# sourceMappingURL=validator.js.map